export const dateFilterOptions = [
    'equals',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
    'notEqual',
    'inRange',
    'blank',
    'notBlank'
];
